<template>
  <div class="container">
    <div class="font_1">
        “获得，<span class="font_2">专业认证</span> 开启你的职业之门，成就卓越人生！”
    </div>
    <div class="font_3">
        专业认证，是你学习之路的光荣标志！让你的努力得到最有力的认可与回报！”
    </div>

    <el-row :gutter="20">
        <el-col :span="13">
            <img src="@/assets/img/card/certificate.jpg" class="certificateImg">
        </el-col>
        <el-col :span="11">
            <el-row :gutter="20">
                <el-col :span="12" class="elStyle_1">
                    <img src="@/assets/img/card/price.png" class="certificateLogo"> <br>
                    <span class="font_4">探索专业技能之路</span> <br>
                    <span class="font_5">“学习，不只是获取知识，更是拓展人生的无限可能！开启职业新征程，塑造未来成功之桥！”</span>
                </el-col>
                <el-col :span="12" class="elStyle_1">
                    <img src="@/assets/img/card/course.png" class="certificateLogo"> <br>
                    <span class="font_4">让您在学海中畅游</span> <br>
                    <span class="font_5">“免费资源，为您呈现无限可能性的舞台，让学习成为成就的起点，而不是阻碍！”</span>
                </el-col>
                <el-col :span="12" class="elStyle_2">
                    <img src="@/assets/img/card/gps.png" class="certificateLogo"> <br>
                    <span class="font_4">点亮您的学习之旅</span> <br>
                    <span class="font_5">“无处不在，免费资源点亮您的学习之旅，无论何时何地，都能享受知识的馈赠！”</span>
                </el-col>
                <el-col :span="12" class="elStyle_2">
                    <img src="@/assets/img/card/plain.png" class="certificateLogo"> <br>
                    <span class="font_4">助您成就更高的职业高度</span> <br>
                    <span class="font_5">“严谨教学，专业把控。我们的教学计划，不仅为您传授知识，更为您指引成功之路！”</span>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.font_1{
    padding-top: 80px;
    font-weight: 550;
    font-size: 35px;
    text-align: center;
}

.font_2 {
    color: rgb(113, 20, 219);
    text-decoration: underline;
    text-decoration-color: rgb(255, 140, 8);
    font-size: 40px;
    text-underline-offset: 5px;
}

.font_3 {
    color: rgb(100, 100, 100);
    font-size: 20px;
    text-align: center;
    margin: 20px 0px;
}

.font_4 {
    font-size: 20px;
    font-weight: bold;
}

.font_5 {
    color: rgb(100, 100, 100);
    font-size: 15px;
}

.elStyle_1 {
    margin-top: 40px;
}

.elStyle_2 {
    margin-top: 100px;
}
.certificateImg {
    margin: 20px 0px;
    width: 600px;
}

.certificateLogo {
    width: 40px;
}
</style>